import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2b3ff85e")

_pushScopeId("data-v-2b3ff85e")
const _hoisted_1 = { class: "circular-border" }
const _hoisted_2 = /*#__PURE__*/_createVNode("p", null, "Selecione um email para enviarmos o código de verificação:", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_header_with_balance = _resolveComponent("header-with-balance")
  const _component_ion_card = _resolveComponent("ion-card")
  const _component_ion_item = _resolveComponent("ion-item")
  const _component_ion_list = _resolveComponent("ion-list")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_content, null, {
        default: _withId(() => [
          _createVNode(_component_header_with_balance, {
            class: "balance-header",
            "has-go-back-modal": true,
            "has-go-back": false,
            title: "Entrar com Telefone"
          }),
          _createVNode("div", _hoisted_1, [
            _hoisted_2,
            _createVNode(_component_ion_list, null, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.user, (email) => {
                  return (_openBlock(), _createBlock(_component_ion_item, {
                    key: email.id,
                    class: "no-padding",
                    onClick: ($event: any) => (_ctx.goLogin(email.email))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_card, null, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(_ctx.formatEmail(email.email)), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                }), 128))
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})